/**
 * Shared UI Constants
 * Animation durations, timing, and other UI-related constants
 */

/**
 * Animation Durations (in milliseconds)
 */
export const ANIMATION = {
  /** Duration for refresh/loading spinner animation - ensures visible feedback */
  SPIN_DURATION_MS: 800,
  /** Standard transition duration for UI elements */
  TRANSITION_MS: 200,
  /** Duration for fade animations */
  FADE_MS: 150,
} as const;

/**
 * Common UI values
 */
export const UI = {
  /** Standard hit slop for touch targets */
  HIT_SLOP: { top: 10, bottom: 10, left: 10, right: 10 },
} as const;
